import { makeStyles } from '@material-ui/core/styles';

export const usePageStyles = makeStyles((theme) => ({
  container: (props) => ({ marginTop: '30px', marginBottom: '35px' }),
}));
